import { t } from "@/i18n-js/instance";
import { LessonFile } from "@/react/components/Spaces/CourseSpace/Shared/LessonFile";
import { useFiles } from "@/react/components/Spaces/CourseSpace/Shared/LessonFile/hooks/useFiles";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";

export const Content = () => {
  const { files, isLoading } = useFiles();

  if (isLoading) {
    return <Loader center />;
  }

  if (files.length === 0) {
    return (
      <div className="overflow-auto px-6 py-4">
        <Typography.LabelSm color="text-light" weight="semibold">
          {t("courses.view_lesson.no_files")}
        </Typography.LabelSm>
      </div>
    );
  }

  return (
    <div className="overflow-auto">
      <div className="px-4 py-2">
        {files.map(file => (
          <LessonFile file={file} key={file.id} />
        ))}
      </div>
    </div>
  );
};
